require("core-js/modules/es6.array.map");

require('../../../modules/es.array.map');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').map;